import $ from 'jquery';
class ColorRangeUI {
    constructor() {
        this.table = $("#colorize-colortable");
    }
    empty() {
        this.table.empty();
    }
    add_color(color) {
        const row = $('<tr></tr>');
        const datum = $('<td></td>');
        $('<div></div>').css('background-color', color).css('height', '20px').appendTo(datum);
        datum.appendTo(row);
        row.appendTo(this.table);
    }
    add_colors(colors) {
        for (let c of colors)
            this.add_color(c);
    }
}
export class ColorRange {
    constructor(opts) {
        this.ui = new ColorRangeUI();
        this._start = opts.start_color;
        this._end = opts.end_color;
        this._steps = opts.num_colors;
        this._opacity = opts.opacity;
        this._jenks = [];
    }
    get start() { return this._start; }
    get end() { return this._end; }
    get steps() { return this._steps; }
    get opacity() { return this._opacity; }
    set start(v) {
        if (v.startsWith('#') && v.length === 7)
            this._start = v;
    }
    set end(v) {
        if (v.startsWith('#') && v.length === 7)
            this._end = v;
    }
    set steps(v) {
        this._steps = v;
    }
    set opacity(v) {
        this._opacity = v;
    }
    update_jenks(jenk_list) {
        this._jenks = jenk_list;
        this.ui.empty();
        this.ui.add_colors(this._jenks);
    }
    get jenks() {
        return this._jenks;
    }
}
